import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { DocsBlockRichTextPropertyStyle } from "../../../../../enums/SDKDocsBlockRichTextPropertyStyle";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.blockquote";
const name = "Quote";
const icon = "https://cdn-assets.supernova.io/blocks/icons/blockquote.svg";
const descriptionShort = "Display a quotation";
const searchKeywords = ["cite", "blockquote"];
const helpText = "Use a blockquote to set off a quotation or cited content from the main text.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/text/blockquote-zYWAsb6X";
/**
 * 2. Block properties
 */
const properties = {
    text: b.richTextProperty({
        id: "text",
        name: "Text",
        options: {
            placeholder: "Write a quote...",
            richTextStyle: DocsBlockRichTextPropertyStyle.quote,
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.text],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.text],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.text,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Blockquote };
